<template>
  <div>
    <div class="loading-update" v-if="updateLoading">
      loading...
      <van-loading style="display: inline-block;" color="black"/>
    </div>
    <p class="message_bottom" v-if="dataEnd">我是有底线的~</p>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {Loading} from 'vant';
  Vue.use(Loading);
  export default {
    props: {
      updateLoading:[String,Boolean],
      dataEnd:[String,Boolean]
    }
  }
</script>

<style lang="less">
  .loading-update{
    height: 100px;
    line-height: 100px;
    text-align: center;
    color: #9a9a9a;
  }
  .message_bottom {
    height: 60px;
    line-height: 60px;
    color: #9a9a9a;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/updateLoading.vue